<template>
  <div
    class="ht-logo"
    :style="{ background: variables[`${style}-menu-background`] }"
  >
    <router-link to="/">
      <div :class="collapse ? 'thumbnail' : 'logoImg'">
        <img v-if="collapse" src="@/assets/images/logo2x.png" alt="" />
        <img v-else :src="logo" />
      </div>
    </router-link>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import variables from '@/styles/variables.scss'
  import { ZH_CODE } from '@transsion/hotent-ui/packages/Language'

  export default {
    name: 'HtLogo',
    data() {
      return {
        variables,
      }
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        style: 'settings/style',
      }),
      logo() {
        return this.$i18n.locale === ZH_CODE
          ? require('@/assets/images/logo.png')
          : require('@/assets/images/logo-en.png')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .thumbnail {
    user-select: none;

    img {
      box-sizing: border-box;
      width: 50px;
      height: 50px;
      padding: 13px;
    }
  }

  .logoImg {
    box-sizing: border-box;
    width: $base-left-menu-width;
    height: $base-nav-bar-height;
    padding: 11px 66px 11px 24px;
    user-select: none;
    image-rendering: pixelated;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>
